import {
  Autocomplete,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { gql } from "@apollo/client";
import { SelectInputV1, useLanguageTranslator } from "../../../components";
import { useApolloQuery } from "../../../hooks";

const policyFormOptionsQueryDocument = gql`
  query policyFormOptionsQuery {
    countryOptions: countries {
      value: id
      label: name
    }
    themeOptions: themes {
      value: id
      label: title
    }
  }
`;

const GET_INDICATORS = gql`
  query GetIndicators {
    indicators {
      id
      label
    }
  }
`;

function Filters({ setFilters, filters }: any) {
  const { translator } = useLanguageTranslator();

  const { data } = useApolloQuery({
    queryDocument: policyFormOptionsQueryDocument,
  });

  const { data: indicatorsList } = useApolloQuery({
    queryDocument: GET_INDICATORS,
    isPrivateCall: true,
  });

  const handleChange = (event: any) => {
    setFilters({ ...filters, [event.target.name]: event.target.value });
  };

  function handleOnChangeIndicatorLabel(event: any) {
    setFilters({ ...filters, [`indicatorLabelId`]: event.target.value });
  }

  return (
    <>
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        sx={{ backgroundColor: "white" }}
        px={3}
      >
        <Typography variant="body2" color="textSecondary">
          {translator("Filter by")}:
        </Typography>
        <FormControl sx={{ minWidth: 120 }}>
          <InputLabel>{translator("Country")}</InputLabel>
          <Select
            label={translator("Country")}
            name="countryId"
            onChange={handleChange}
          >
            {[
              { value: "0", label: translator("All") },
              ...(data?.countryOptions || []),
            ]?.map((op: any, i: any) => (
              <MenuItem key={`${op.value}-${i}`} value={op.value}>
                {op.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ minWidth: 120 }}>
          {/* <InputLabel
            sx={{
              background: "white",
              paddingLeft: "10px",
              paddingRight: "10px",
            }}
          >
            {translator("Indicator Label")}
          </InputLabel> */}
          <Autocomplete
            sx={{ width: "400px" }}
            options={[
              { id: "0", label: translator("All") },
              ...(indicatorsList?.indicators || []),
            ]}
            getOptionLabel={(option: any) => option.label}
            onChange={(event, newValue) =>
              handleOnChangeIndicatorLabel({
                target: {
                  name: "indicatorCategoryId",
                  value: newValue?.id || "",
                },
              })
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label={translator("Indicator Label")}
                variant="outlined"
              />
            )}
            isOptionEqualToValue={(option, value) => option.id === value.id}
          />
        </FormControl>

        <FormControl sx={{ minWidth: 120 }}>
          <InputLabel>{translator("Theme")}</InputLabel>
          <Select
            sx={{ width: 150 }}
            label="Theme"
            name="themeId"
            onChange={handleChange}
          >
            {[
              { value: "0", label: translator("All") },
              ...(data?.themeOptions || []),
            ]?.map((op: any, i: any) => (
              <MenuItem key={`${op.value}-${i}`} value={op.value}>
                {op.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>
    </>
  );
}

export { Filters };
